import React, { useCallback, useState } from 'react';
interface CTAButtonProps {
  text: string;
  href?: string;
  className?: string;
  isExternal?: boolean;
}
export function CTAButton({
  text,
  href = '#compra',
  className = '',
  isExternal = false
}: CTAButtonProps) {
  const [isPressed, setIsPressed] = useState(false);
  const handleClick = useCallback((e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setIsPressed(true);
    const delay = isExternal ? 900 : 600;
    setTimeout(() => {
      if (isExternal) {
        window.location.href = href;
      } else {
        const targetId = href.replace('#', '');
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
      setIsPressed(false);
    }, delay);
  }, [href, isExternal]);
  return <a href={href} onClick={handleClick} target={isExternal ? '_blank' : '_self'} rel={isExternal ? 'noopener noreferrer' : ''} className={`
        block w-full max-w-2xl mx-auto text-center cursor-pointer
        bg-green-500 hover:bg-green-600 text-white 
        font-extrabold text-xl md:text-2xl lg:text-3xl 
        py-5 px-8 rounded-xl shadow-[0_8px_15px_rgba(34,197,94,0.4)]
        transition-all duration-500 ease-in-out
        border-b-4 border-green-700 active:border-b-0 active:translate-y-1
        ${isPressed ? 'scale-95 brightness-110 border-b-0 translate-y-1 shadow-[0_2px_8px_rgba(34,197,94,0.3)]' : 'animate-cf-pulse'}
        ${className}
      `} data-id="element-6">
      {text}
    </a>;
}